import { render } from "./grupoestatusmasterdetail.vue?vue&type=template&id=4f4c5fb9"
import script from "./grupoestatusmasterdetail.vue?vue&type=script&lang=js"
export * from "./grupoestatusmasterdetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__